import { createSelector } from '@ngrx/store';

import { getWizzardMenuFlowAllPageProducts } from '../getWizzardMenuFlowAllPageProducts';

export const getWizzardMenuFlowPageFirstProduct = (pageIdentifier: number) =>
    createSelector(getWizzardMenuFlowAllPageProducts(pageIdentifier), (products) => products?.[0] || null);
